import React from "react";
import { useLocation } from "react-router-dom";
import {
  Box,
  Grid,
  Typography,
  Link,
  Divider,
} from "@mui/material";
import {
  Facebook,
  Instagram,
  YouTube,
  LinkedIn,
  ConfirmationNumber,
  BusinessSharp,
  Assignment,
} from "@mui/icons-material";
import { LocationOn, Phone, Email, Language } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";


const Footer = () => {
  const location = useLocation();
  return (
    <Box
      sx={{
        backgroundColor: "#ffffff",
        padding: "60px 20px",
        boxShadow: "0px -2px 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      {/* Footer Content */}
      <Grid
        container
        spacing={6}
        justifyContent="space-between"
        alignItems="flex-start"
      >
        {/* Left Section: Logo and Description */}

        {/* Left Section: Logo and Description */}
        <Grid item xs={12} md={5}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: { xs: "center", md: "flex-start" },
            }}
          >
            {/* Logo */}
            <Link href="/" sx={{ display: "flex", justifyContent: "center" }}>
              <Box
                component="img"
                src="/LOGOS/Farmology-Logo-e1687720251448.png"
                alt="Logo"
                sx={{ height: "60px", mb: 3 }}
              />
            </Link>

            {/* Description */}
            <Typography
              variant="body1"
              sx={{
                color: "#777",
                textAlign: "justify",
                lineHeight: 1.7,
                ml: { xs: 3, md: 0 }, // margin-left ONLY on mobile
              }}
            >
              Farmology is dedicated to empowering farmers through technology
              and sustainable practices. We offer unbiased crop advisory
              services, organic agricultural inputs, and advanced solutions like
              AI-driven crop health monitoring. Our platform enables farmers to
              identify crop issues, access soil health reports, and receive
              precise recommendations in regional languages. Additionally, we
              facilitate the sale of produce at premium prices by eliminating
              intermediaries. Our vision is to build trust among agricultural
              stakeholders, benefiting the entire ecosystem. Join us in
              fostering sustainable development for a sustainable future.
            </Typography>

            {/* <Typography
              variant="h6"
              sx={{
                color: "#333",
                fontWeight: "bold",
                textAlign: { xs: "center", md: "left" },
              }}
            >
              Compan
            </Typography> */}

            {/* Address with Location Icon */}

            {/* <Typography
              variant="h6"
              sx={{
                color: "#333",
                fontWeight: "bold",
                textAlign: { xs: "center", md: "left" },
              }}
            >
              Company Details
            </Typography> */}
          </Box>
        </Grid>

        {/* Middle Section: Contact Information */}
        <Grid item xs={12} md={4}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              marginTop: 2,
              ml: 3,
              textAlign: { xs: "center", md: "left" },
              justifyContent: { xs: "center", md: "flex-start" }, // Center on mobile
              alignItems: { xs: "center", md: "flex-start" }, // Center on mobile
            }}
          >
            <Typography
              variant="h6"
              sx={{
                color: "#333",
                fontWeight: "bold",
                textAlign: { xs: "center", md: "left" },
              }}
            >
              Contact Info
            </Typography>

            <Typography
              variant="body2"
              sx={{
                color: "#666",
                lineHeight: 1.8,
                textAlign: { xs: "center", md: "left" },
                alignItems: "center",
                display: "flex",
                marginTop: 2,
              }}
            >
              <BusinessSharp sx={{ mr: 1, color: "#00695c" }} />
              <span>
                <b>Company Name:</b> Surobhi Agro Industries Pvt. Ltd.
              </span>
            </Typography>
            <Typography
              variant="body2"
              sx={{
                alignItems: "center",
                color: "#666",
                marginTop: 1,
                display: "flex",
                textAlign: { xs: "center", md: "left" },
                lineHeight: 1.8,
              }}
            >
              <ConfirmationNumber sx={{ mr: 1, color: "#00695c" }} />
              <span>
                <b>GST Number:</b> 19ABBCS3198L1ZQ
              </span>
            </Typography>

            <Typography
              variant="body2"
              sx={{
                display: "flex",
                alignItems: "center",
                color: "#666",
                marginTop: 1,
                textAlign: { xs: "center", md: "left" },
                lineHeight: 1.8,
              }}
            >
              <Assignment sx={{ mr: 1, color: "#00695c" }} />
              <b>CIN:</b>
              U01100WB2018PTC229465
            </Typography>

            <Typography
              variant="body2"
              sx={{
                display: "flex",
                marginTop: 1,
                color: "#666",
                lineHeight: 1.8,
                textAlign: { xs: "center", md: "left" },
              }}
            >
              <LocationOn sx={{ mr: 1, color: "#00695c" }} />
              <span>
                <b>Corporate Office:</b> Surobhi Agro Industries Private
                Limited - East India coworking- Eden, 2nd floor, Hanuman Estates,
                19, RN Mukherjee Rd, Esplanade, Lal Bazar, Kolkata,
                West Bengal 700001
                <Link
                  href="https://maps.app.goo.gl/TyQGinpuEo52Tae26"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    color: "#00695c",
                    textDecoration: "none",
                    "&:hover": { color: "#000" },
                    ml: 2,
                  }} // Added marginLeft here
                >
                  View on Map
                </Link>
              </span>
            </Typography>

            {/* Phone with Phone Icon */}
            <Typography
              variant="body2"
              sx={{
                display: "flex",
                alignItems: "center",
                color: "#666",
                marginTop: 1,
                textAlign: { xs: "center", md: "left" },
                lineHeight: 1.8,
              }}
            >
              <Phone sx={{ mr: 1, color: "#00695c" }} />
              <b>Phone:</b>
              <Link
                href="tel:+917044245566"
                sx={{
                  color: "#666",
                  textDecoration: "none",
                  "&:hover": { color: "#000" },
                  ml: 1,
                }}
              >
                +91-7044245566
              </Link>
            </Typography>

            {/* Email with Email Icon */}
            <Typography
              variant="body2"
              sx={{
                display: "flex",
                alignItems: "center",
                color: "#666",
                marginTop: 1,
                textAlign: { xs: "center", md: "left" },
                lineHeight: 1.8,
              }}
            >
              <Email sx={{ mr: 1, color: "#00695c" }} />
              <b>Email:</b>
              <Link
                href="mailto:info@farmologyindia.com"
                sx={{
                  color: "#666",
                  textDecoration: "none",
                  "&:hover": { color: "#000" },
                  ml: 1,
                }}
              >
                info@farmologyindia.com
              </Link>
            </Typography>

            {/* Website with Language Icon */}
            <Typography
              variant="body2"
              sx={{
                display: "flex",
                alignItems: "center",
                color: "#666",
                marginTop: 1,
                textAlign: { xs: "center", md: "left" },
                lineHeight: 1.8,
              }}
            >
              <Language sx={{ mr: 1, color: "#00695c" }} />
              <b>Website:</b>
              <Link
                href="https://www.farmology.ai"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: "#666",
                  textDecoration: "none",
                  "&:hover": { color: "#000" },
                  ml: 1,
                }}
              >
                www.farmology.ai
              </Link>
            </Typography>
          </Box>
        </Grid>

        {/* Right Section: Social Media */}
        <Grid item xs={12} md={3}>
          <Typography
            variant="h6"
            marginTop={2}
            sx={{
              color: "#333",
              fontWeight: "bold",
              textAlign: { xs: "center", md: "left" },
            }}
          >
            Follow Us
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: { xs: "center", md: "left" },
              gap: 2,
              marginTop: 2,
            }}
          >
            <a
              href="https://www.facebook.com/p/Farmology-100063893500354/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Facebook
                sx={{
                  color: "#3b5998",
                  fontSize: 30,
                  "&:hover": { color: "#2d4373" },
                }}
              />
            </a>
            <a
              href="https://www.youtube.com/channel/UCgjha5OQ4B0pdntZGAncvaQ"
              target="_blank"
              rel="noopener noreferrer"
            >
              <YouTube
                sx={{
                  color: "#FF0000",
                  fontSize: 30,
                  "&:hover": { color: "#cc0000" },
                }}
              />
            </a>
            <a
              href="https://www.instagram.com/farmo_logy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Instagram
                sx={{
                  color: "#E1306C",
                  fontSize: 30,
                  "&:hover": { color: "#C13584" },
                }}
              />
            </a>
            <a
              href="https://in.linkedin.com/company/farmology-surobhi-agro"
              target="_blank"
              rel="noopener noreferrer"
            >
              <LinkedIn
                sx={{
                  color: "#0e76a8",
                  fontSize: 30,
                  "&:hover": { color: "#004182" },
                }}
              />
            </a>
          </Box>

          {/* Quick Links */}
          <Typography
            variant="h6"
            sx={{
              color: "#333",
              fontWeight: "bold",

              textAlign: { xs: "center", md: "left" },
              marginTop: 4,
            }}
          >
            Quick Links
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,

              marginTop: 2,
              textAlign: { xs: "center", md: "left" },
            }}
          >
            <Link
              href="/about"
              variant="body2"
              sx={{
                color: "#00695c",
                textDecoration: "underline",
                fontWeight: 600,
                "&:hover": {
                  textDecoration: "underline",
                  color: "#51833a", // Change color on hover
                },
              }}
            >
              About Us
            </Link>
            <Link
              href="/service"
              variant="body2"
              sx={{
                color: "#00695c",
                textDecoration: "underline",
                fontWeight: 600,
                "&:hover": {
                  textDecoration: "underline",
                  color: "#51833a", // Change color on hover
                },
              }}
            >
              Our Services
            </Link>
            <Link
              href="/pricing"
              variant="body2"
              sx={{
                color: "#00695c",
                textDecoration: "underline",
                fontWeight: 600,
                "&:hover": {
                  textDecoration: "underline",
                  color: "#51833a", // Change color on hover
                },
              }}
            >
              Pricing
            </Link>

            <Link
              href="/contact"
              variant="body2"
              sx={{
                color: "#00695c",
                textDecoration: "underline",
                fontWeight: 600,
                "&:hover": {
                  textDecoration: "underline",
                  color: "#51833a", // Change color on hover
                },
              }}
            >
              Contact Us
            </Link>
            <Link
              href="/sitemap.xml"
              variant="body2"
              sx={{
                color: "#00695c",
                textDecoration: "underline",
                fontWeight: 600,
                "&:hover": {
                  textDecoration: "underline",
                  color: "#51833a", // Change color on hover
                },
              }}
            >
              Sitemap
            </Link>
          </Box>
        </Grid>
      </Grid>

      {/* Divider Line */}
      <Divider sx={{ backgroundColor: "#e0e0e0", marginY: 4 }} />

      {/* Bottom Section: Policy Links and Copyright */}
      <Grid container spacing={2} justifyContent="center" alignItems="center">
        <Grid item xs={12} sm={6}>
          <Typography
            variant="body2"
            sx={{ color: "#777", textAlign: "center" }}
          >
            {/* Privacy Policy Link */}
            <Link
              component={RouterLink}
              to="/privacy-policy"
              underline="none"
              sx={{
                color:
                  location.pathname === "/privacy-policy" ? "#000" : "#777", // Dark color when active
                fontWeight:
                  location.pathname === "/privacy-policy" ? "bold" : "normal",
                "&:hover": { color: "#000" },
                marginRight: 2,
              }}
            >
              Privacy Policy
            </Link>

            {/* Terms of Service Link */}
            <Link
              component={RouterLink}
              to="/terms-of-service"
              underline="none"
              sx={{
                color:
                  location.pathname === "/terms-of-service" ? "#000" : "#777", // Dark color when active
                fontWeight:
                  location.pathname === "/terms-of-service" ? "bold" : "normal",
                "&:hover": { color: "#000" },
                marginRight: 2,
              }}
            >
              Terms of Service
            </Link>

            {/* Refund Policy Link */}
            <Link
              component={RouterLink}
              to="/refund-policy"
              underline="none"
              sx={{
                color: location.pathname === "/refund-policy" ? "#000" : "#777", // Dark color when active
                fontWeight:
                  location.pathname === "/refund-policy" ? "bold" : "normal",
                "&:hover": { color: "#000" },
              }}
            >
              Refund Policy
            </Link>
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography
            variant="body2"
            sx={{ color: "#777", textAlign: "center" }}
          >
            Copyright © {new Date().getFullYear()} Surobhi Agro Industries Pvt.
            Ltd. All rights reserved.
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Footer;
